<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="m-3">
                <b-col>
                    <div>
                        <p class="font-weight-bold">SECTION F: ACADEMIC STANDARDS AND FINANCIAL GOOD STANDING</p>
                    </div>
                    <ul>
                        <li>
                            <strong>Academic Progression &amp; Sequential Requirements:</strong> The Continuing
                            Education program is a non-degree program. Courses in this program are non-sequential. You
                            must successfully attend 80% of the course/workshop or training to qualify for a completion
                            certificate.
                        </li>
                        <li>
                            <strong>Attendance Policy:</strong> A minimum of 80% attendance is mandatory for all
                            modalities (in-person, online or hybrid).
                        </li>
                        <li>
                            <strong>Account Delinquency &amp; Service Suspension:</strong> Services, including access to
                            the LMS. Final certification release will be immediately suspended for students
                            with an outstanding financial balance due. Course marks will not be certified until
                            financial balances are clear.
                        </li>
                        <li>
                            <strong>Delinquent Penalties:</strong> Unpaid balances may be sent to collection procedures
                            with the DC Office of Tax and Revenue and the Office of the Attorney General,
                            incurring an additional collection penalty up to thirty percent (30%) of the past
                            due balance, administrative costs, and reasonable attorney fees.
                        </li>
                        <li>
                            <strong>Late Fees &amp; Returned Checks:</strong> Failure to make payment deadlines results in a
                            $80 late fee. A $35 fee is assessed for unpaid checks returned by banks.
                        </li>
                        <li>
                            <strong>Exceptional Mitigation:</strong> In documented instances of prolonged illness,
                            accidents, or death in the immediate family, the administration will work toward
                            an equitable and fair programmatic accommodation.
                        </li>
                    </ul>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <b-row class="d-flex align-items-center flex-column flex-md-row justify-content-md-between">
                        <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                            <ValidationProvider
                                name="status"
                                rules="required"
                                v-slot="{ valid, errors }"
                            >
                                <div class="d-flex flex-row-reverse">
                                    <b-form-checkbox
                                        id="checkbox-ce-f"
                                        v-model="form.status"
                                        name="checkbox-ce-f"
                                        value="accepted"
                                        :unchecked-value="null"
                                        class="text-sm text-md-md ml-4"
                                    >
                                    </b-form-checkbox>
                                    <div>
                                        I read and confirm that I understand the information in Section F.
                                    </div>
                                </div>
                                <b-form-invalid-feedback v-if="errors[0]">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" class="text-md-right mt-3">
                            <b-button
                                type="submit"
                                @click="next"
                                variant="primary"
                                class="w-100 w-md-auto"
                            >
                                {{ $t('next') }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>
<script>
export default {
    data() {
        return {
            form: {},
        }
    },
    created() {
        window.scrollTo(0, 0)
    },
    methods: {
        async next() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                this.$emit('next', 1)
            }
        },
        back() {
            this.$emit('back', -1);
        }
    }
}
</script>
